// @flow

import * as React from 'react';
import { Route, Link } from 'react-router-dom';
import AzScroller from '@adactive/az-scroller';
import type { ListItem, SectionHeaderInfo } from '@adactive/az-scroller';

import { Header } from './components/Header';

import AceEditor from 'react-ace';

import brace from 'brace';
import 'brace/mode/jsx';
import 'brace/theme/monokai';

import './App.css';

type PropsType = {||};

class App extends React.Component<PropsType> {
    render() {
        const list = [
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'A'
                },
                items: [
                    { text: 'ABEL' },
                    { text: 'ABRAHAM' },
                    { text: 'ACHILLE' },
                    { text: 'ADAM' },
                    { text: 'ADÈLE' },
                    { text: 'ADELINE' },
                    { text: 'ADOLPHE' },
                    { text: 'ANTOINE' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'B'
                },
                items: [
                    { text: 'BAPTISTE' },
                    { text: 'BARBARA' },
                    { text: 'BARNABÉ' },
                    { text: 'BARTHÉLÉMY' },
                    { text: 'BASILE' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'C'
                },
                items: [
                    { text: 'CERISE' },
                    { text: 'CÉSAIRE' },
                    { text: 'CHARLES' },
                    { text: 'CHARLOT' },
                    { text: 'CHRISTIAN' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'E'
                },
                items: [
                    { text: 'ESTELLE' },
                    { text: 'ETHAN' },
                    { text: 'ÉTIENNE' },
                    { text: 'EUGÈNE' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'M'
                },
                items: [
                    { text: 'MICHÈLE' },
                    { text: 'MOROINE' },
                    { text: 'MURIELLE' },
                    { text: 'MYLÈNE' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'S'
                },
                items: [
                    { text: 'SEBASTIAN' },
                    { text: 'SEREN' },
                    { text: 'STANLEY' },
                    { text: 'STÉPHANE' },
                    { text: 'SYBILLE' },
                    { text: 'SYLVAIN' },
                ]
            },
            {
                sectionHeaderInfo: {
                    type: 'SectionHeaderInfo',
                    letter: 'W'
                },
                items: [
                    { text: 'WANDY' },
                    { text: 'WAN' },
                    { text: 'WREN' },
                    { text: 'WILGELM' },
                    { text: 'WADE' },
                    { text: 'WILLIAM' },
                    { text: 'WINOC' }
                ]
            }
        ];

        return (
            <div className="App">
                <Header logo={"http://adactivesas.github.io/adsum-react-components/logo.jpg"} />
                <br/>
                <div className="snippetWrapper">

                    <div className="comp" >
                        <div style={{ width: 300 }}>
                            <AzScroller
                                maxHeight={220}
                                list={list}
                                shouldShowSectionHeaders={true}
                                renderListItem={(listItem: ListItem, key: string | number): Node => (
                                    <div key={key}>
                                        {listItem.text}
                                    </div>
                                )}
                                renderListSectionHeader={(headerInfo: SectionHeaderInfo, key: string | number): Node => (
                                    <li key={key}>
                                        {`Section header of letter ${key}`}
                                    </li>
                                )}
                                sectionHeaderHeight={18}
                                listItemHeight={18}
                            />
                        </div>
                    </div>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{$blockScrolling: true}}
                            fontSize={14}
                            showPrintMargin={true}
                            showGutter={true}
                            readOnly={true}
                            tabSize={4}
                            value="<AzScroller$
                            maxHeight={220}
                            list={list}
                            shouldShowSectionHeaders={true}
                            renderListItem={(listItem: ListItem, key: string | number): Node => (
                                <div key={key}>
                                    {listItem.text}
                                </div>
                            )}
                            renderListSectionHeader={(headerInfo: SectionHeaderInfo, key: string | number): Node => (
                                <li key={key}>
                                    {`Section header of letter ${key}`}
                                </li>
                            )}
                            sectionHeaderHeight={18}
                            listItemHeight={18}
                        />"
                            height='200px'
                            width='1000px'
                        />
                    </div>
                </div>
                <div className="snippetWrapper">
                    <div className="comp" >
                        <div style={{ width: 300 }}>
                            <AzScroller
                                maxHeight={220}
                                list={list}
                                shouldShowSectionHeaders={false}
                                renderListItem={(listItem: ListItem, key: string | number): Node => (
                                    <div key={key}>
                                        {listItem.text}
                                    </div>
                                )}
                                renderListSectionHeader={(headerInfo: SectionHeaderInfo, key: string | number): Node => (
                                    <li key={key}>
                                        {`Section header of letter ${key}`}
                                    </li>
                                )}
                                sectionHeaderHeight={18}
                                listItemHeight={18}
                            />
                        </div>
                    </div>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{$blockScrolling: true}}
                            fontSize={14}
                            showPrintMargin={true}
                            showGutter={true}
                            readOnly={true}
                            tabSize={4}
                            value="<AzScroller$
                            maxHeight={220}
                            list={list}
                            shouldShowSectionHeaders={false}
                            renderListItem={(listItem: ListItem, key: string | number): Node => (
                                <div key={key}>
                                    {listItem.text}
                                </div>
                            )}
                            renderListSectionHeader={(headerInfo: SectionHeaderInfo, key: string | number): Node => (
                                <li key={key}>
                                    {`Section header of letter ${key}`}
                                </li>
                            )}
                            sectionHeaderHeight={18}
                            listItemHeight={18}
                        />"
                            height='200px'
                            width='1000px'
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js